<template>
  <iVideoContainer
    ref="video"
    :src="videoSrc"
    :height="getOptionValue(LayoutHeight)"
    :min-height="getOptionValue(MinHeight)"
    :max-height="getOptionValue(MaxHeight)"
    :width="getOptionValue(LayoutWidth)"
    :min-width="getOptionValue(MinWidth)"
    :max-width="getOptionValue(MaxWidth)"
    :autoplay="getOptionValue(Autoplay) === 'whenScrolledIntoView'"
    :controls="getOptionValue(Controls)"
    :toggle-on-press="!gestureOwnsTheClick"
    :muted="getOptionValue(Muted)"
    :loop="getOptionValue(Loop)"
    :poster="posterSrc"
    :border-top="myBorderSides?.top ?? 0"
    :border-bottom="myBorderSides?.bottom ?? 0"
    :border-left="myBorderSides?.left ?? 0"
    :border-right="myBorderSides?.right ?? 0"
    :style-overrides="videoStyleOverrides"
  />
</template>

<script>
// Production variant for unselected `VideoElement`s. Template + mixin
// chain is identical to the Builder variant — there is no edit-only
// affordance inside the element itself, so the win comes from the
// canvas-side Builder wrapper short-circuiting its overlays + the
// breakpoint-frame swap.
import {
  StandardVideoElementMixin,
} from "%/dynamic-component-editor/standard-elements/video-element/standard-video-element-mixin";
import {
  SingleVideoElementMixin,
} from "%/dynamic-component-editor/standard-elements/video-element/single-video-element-mixin";

export default {
  name: "VideoElementProduction",
  // Production twin: exempt from the palette's elementPanelSettings gate.
  production: true,
  mixins: [StandardVideoElementMixin, SingleVideoElementMixin],
};
</script>
